module.exports = __webpack_public_path__ + "static/img/13.7e66a69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/13.png
// module id = qvgY
// module chunks = 0